export type TAnswer = {
  id: number;
  weight: number;
  text: string;
};
export type TQuestion = {
  id: number;
  question: string;
  answers: Array<TAnswer>;
};

export const questions: Array<TQuestion> = [
  {
    id: 1,
    question:
      'Начнём с простого: понедельник, начало рабочей недели. Как подступитесь к делам?',
    answers: [
      {
        id: 1,
        weight: 0,
        text: 'Сначала составлю топ целей на эту неделю. Потом распишу всё поминутно — важен очень чёткий план.',
      },
      {
        id: 2,
        weight: 1,
        text: 'Уже знаю цель на эту неделю. Но как к ней прийти — без понятия.',
      },
      {
        id: 3,
        weight: 2,
        text: 'За выходные придумалось столько крутых идей! Некогда планировать, пора работать!',
      },
    ],
  },
  {
    id: 2,
    question: 'Закончите фразу: «Мне никогда не…»',
    answers: [
      {
        id: 4,
        weight: 0,
        text: 'казалось, что я делаю что-то зря.',
      },
      {
        id: 5,
        weight: 1,
        text: 'хотелось ограничивать себя в мечтах и стремлениях.',
      },
      {
        id: 6,
        weight: 2,
        text: 'было страшно пробовать новое.',
      },
    ],
  },
  {
    id: 7,
    question: 'Вы нашли партнёра в свой проект. Где проведёте переговоры?',
    answers: [
      {
        id: 8,
        weight: 0,
        text: 'Решим организационные вопросы в чате, в крайнем случае — слетимся на видео-встречу.',
      },
      {
        id: 9,
        weight: 1,
        text: 'Предложу встречу в офисе инвестора или приглашу на чашку кофе на нейтральной территории. Личный контакт очень важен!',
      },
      {
        id: 10,
        weight: 2,
        text: 'В моём офисе! Так сразу погружу партнёра в нужную атмосферу.',
      },
    ],
  },
  {
    id: 4,
    question:
      'Время отпуска! Как сделать так, чтобы без вас ничего не рухнуло?',
    answers: [
      {
        id: 11,
        weight: 0,
        text: 'Собрать инструкцию, описать все процессы, настроить автоответы в почте. И обязательно назначить заместителей!',
      },
      {
        id: 12,
        weight: 1,
        text: 'Просто предупредить всех заранее — пусть успевают обсудить все дела до того, как я окажусь на пляже.',
      },
      {
        id: 13,
        weight: 2,
        text: 'Отпуск? А что это?',
      },
    ],
  },
  {
    id: 5,
    question: 'И последнее. Кря?',
    answers: [
      {
        id: 14,
        weight: 0,
        text: 'Какое кря?',
      },
      {
        id: 15,
        weight: 1,
        text: 'Может кря, а может и кря — как пойдёт.',
      },
      {
        id: 16,
        weight: 2,
        text: 'Троекратное кря-кря-кря!',
      },
    ],
  },
];
